<template>
  <div class="abs">
    <div class="abs-header">
      <button class="abs-button" />
      <div>
        <div class="label">
          Behind the scenes
        </div>
        <div class="name">
          {{ name }}
        </div>
      </div>
    </div>
    <div class="abs-about">
      <div class="abs-photo">
        <img
          :src="img"
          :alt="name"
        >
      </div>
      <div class="abs-description">
        <div class="title">
          Description
        </div>
        <p>{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'abs-popup-description',
  props: {
    img: {
      type: String,
      required: true,
      default: '',
    },
    name: {
      type: String,
      required: true,
      default: '',
    },
    description: {
      type: String,
      required: true,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.abs {

  &-header {
    display: flex;
    margin-bottom: 24px;
  }

  &-about {
    display: flex;
  }

  &-button {
    width: 30px;
    height: 30px;
    margin-right: 16px;
    border: none;
    box-shadow: 0 2px 2px 1px rgba(50, 50, 90, 0.23);
    border-radius: 3px;
    background-color: #32325a;
    background-image: url('../assets/icons/arrow-down.png');
    background-repeat: no-repeat;
    background-size: 10px auto;
    background-position: center;
  }

  &-photo {
    width: 125px;
    height: 125px;
    margin-right: 24px;
    position: relative;
    overflow: hidden;

    img {
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      object-fit: cover;
    }
  }

  &-description {
    padding: 10px 0;
    max-width: 450px;

    .title {
      margin-bottom: 15px;
    }

    p {
      color: #6e7c91;
      font-size: 15px;
      font-weight: 500;
      line-height: 1.3;
    }
  }
}

.label {
  margin-bottom: 8px;
  color: #6e7c91;
  font-size: 9px;
  text-transform: uppercase;
}

.name, .title {
  color: #6e7c91;
  font-size: 15px;
  font-weight: 700;
}
</style>
